import { EventsByResourceType, EventsListType } from "../../SchedulingTypes"

// Set constants
const EVENT_HEIGHT = 30
const EVENT_MARGIN = 3
const BASE_ROW_HEIGHT = 83  // was 64

// Calculates the row height based on the number of events within the resource
export const calculateRowHeight = (
    resourceId: string | number,
    eventsByResource: EventsByResourceType,
    events: EventsListType
) => {
    // Get the events for the given resource id
    const resourceEventIds = eventsByResource[resourceId] || []

    // When the resource has no events, return the base row height
    if (resourceEventIds.length === 0) {
        return `${BASE_ROW_HEIGHT}px`
    }

    // Loop through the events to count the amount
    const eventsPerDay: Record<string, number> = {}
    resourceEventIds.forEach(id => {
        const event = events[id]
        if (!event) return

        const key = event.dayKey
        eventsPerDay[key] = (eventsPerDay[key] || 0) + 1
    })

    // Count the maximum amount of events
    const maxEvents = Math.max(...Object.values(eventsPerDay))

    // Calculate the height
    const eventHeight = EVENT_HEIGHT + EVENT_MARGIN
    const requiredHeight = (maxEvents + 1) * eventHeight

    return `${Math.max(requiredHeight, BASE_ROW_HEIGHT)}px`
}